import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "../../../components/common/useToast";

// Fires the "minimum votes" info toast once on mount (auto-dismisses after 10s)
// via the global Toaster. Renders nothing itself.
const InfoToast = ({ minVotes }) => {
  const { t } = useTranslation();
  const toast = useToast();

  useEffect(() => {
    toast.info(t("singles_inferno.min_votes_message", { minVotes }), { duration: 10000 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minVotes]);

  return null;
};

export default InfoToast;
